import PropTypes from "prop-types"
import React from "react"
import { Col, Modal, ModalBody, Row } from "reactstrap"

const ErrorModal = ({ show, onCloseClick }) => {
  return (
    <Modal isOpen={show != "" && true} toggle={onCloseClick} centered={true}>
      <ModalBody className="py-3 px-5">
        <Row>
          <Col lg={12}>
            <div className="text-center">
              <i
                className="mdi mdi-close-circle-outline"
                style={{ fontSize: "9em", color: "orange" }}
              />
              <h2>Error</h2>
              <h4>{show}</h4>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="text-center mt-3">
              <button
                type="button"
                className="btn btn-danger btn-lg ms-2"
                onClick={onCloseClick}
              >
                Close
              </button>
            </div>
          </Col>
        </Row>
      </ModalBody>
    </Modal>
  )
}

ErrorModal.propTypes = {
  onCloseClick: PropTypes.func,
  show: PropTypes.any,
}

export default ErrorModal
